import React from 'react';
import { useHistory } from 'react-router';
import { IonButton, IonContent, IonIcon, IonGrid, IonRow, IonCol, IonPage, IonTitle } from '@ionic/react';
import { useURLStore } from './stateManagement/URLZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import CommonHeader from './CommonHeader';
import { home, trash } from 'ionicons/icons';
import { _dict, _pathSeparator } from './constants';
import { Breadcrumbs } from './Breadcrumbs';

function Homeworks() {
    const { getURLTo } = useURLStore();
    const { homeworks, removeFromHomeworks } = useTreeStore();
    const { lang } = useGlobalStore();

    const history = useHistory();

    let extraJSX = (
        <>
        <IonButton fill="solid" color="light" shape="round" onClick={() => { history.push(getURLTo().home()) }}>
            <IonIcon slot="icon-only" color="dark" icon={home} size="large"></IonIcon>
        </IonButton>
        <IonTitle>{_dict.homeworks[lang]}</IonTitle>
        </>

    );
    if(homeworks.length === 0){
        history.push(getURLTo().home());
    }
    return (
        <IonPage>
            
            <CommonHeader extraJSX={extraJSX} />
            <IonContent>
                <IonGrid>
                    {homeworks.map((homework, index) => (
                        <IonRow key={index} className="ion-align-items-center">
                            <IonCol size="auto" onClick={() => history.push(getURLTo().talkFromCustomNodePath(homework))}>
                                <Breadcrumbs path={homework} pathSeparator={_pathSeparator} />
                            </IonCol>
                            <IonCol size="auto">
                                <IonButton fill="clear" color="danger" onClick={() => {
                                    removeFromHomeworks([homework]);
                                }}>
                                    <IonIcon icon={trash} />
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    ))}
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}

export default Homeworks;
